import axios from '@/libs/api.request'

const Api = {
  MemberPlans: '/member/plans',
  MemberPlanOrder: '/member/plan/order'
}

export const getPlans = (data) => {
  return axios.request({
    url: Api.MemberPlans,
    data: data,
    method: 'post'
  })
}

export const orderPlan = (data) => {
  return axios.request({
    url: Api.MemberPlanOrder,
    data: data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/plan.js